// extracted by mini-css-extract-plugin
export default {"flexContainer":"Toolbar-module__flexContainer___T5V6Z","spacer":"Toolbar-module__spacer___CsI5b"};